import React from "react";
import NewsArticle from "../Components/Ambassador/News/NewsArticle";

const AmbassadorNewsItemPage: React.FC = () => <NewsArticle />;

export default AmbassadorNewsItemPage;
